import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { CookiesPolicyComponent } from './components/cookies-policy/cookies-policy.component';
import { LandingComponent } from './components/landing/landing.component';
import { MapComponent } from './components/map/map.component';
import { MarkerInfoComponent } from './components/marker-info/marker-info.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
  },
  {
    path: 'home',
    component: LandingComponent,
  },
  {
    path: 'map',
    component: MapComponent,
  },
  {
    path: 'field-info',
    component: MarkerInfoComponent,
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
  },
  {
    path: 'contacts',
    component: ContactsComponent,
  },
  {
    path: 'cookies',
    component: CookiesPolicyComponent,
  },
  {
    path: 'privacy',
    component: PrivacyPolicyComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      initialNavigation: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
